import React from 'react';
import styles from './TopBar.module.scss';
import Flex from '../../Flex/Flex';
import SiteLinks from '../SiteLinks/SiteLinks';
import { TopBarItemShape } from '../SiteLink/SiteLink';
import { LinkAdapter } from '../../Link/Link';

type TopBarProps = {
  /** Segment links */
  segments?: TopBarItemShape[];
  /** Language links */
  languages?: TopBarItemShape[];
  /** Custom link or for injecting third party routing link */
  linkAdapter?: LinkAdapter;
};
// Alias for backwards compatibility
export type TopBarShape = TopBarProps;

const TopBar: React.FunctionComponent<TopBarProps> = ({
  segments,
  languages,
  linkAdapter,
}) => {
  return (
    <Flex
      centeredVertically
      spaceBetween={!!segments}
      reverseDirection={!!languages && !segments}
      className={styles.topBar}
    >
      {segments && (
        <SiteLinks
          data-testid="segment-site-links"
          links={segments}
          linkAdapter={linkAdapter}
        ></SiteLinks>
      )}
      {languages && (
        <SiteLinks
          data-testid="language-site-links"
          links={languages}
          linkAdapter={linkAdapter}
        ></SiteLinks>
      )}
    </Flex>
  );
};

export default TopBar;
